// @ts-expect-error module not typed
import { HUBSPOT_HOSTED } from 'conversations-internal-schema/connected-email-account/constants/EmailAccountTypes';
// @ts-expect-error module not typed
import { getEmailAccountType } from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
export const isAccountHubspotHosted = connectedAccount => {
  const accountType = connectedAccount && getEmailAccountType(connectedAccount);
  return accountType === HUBSPOT_HOSTED;
};